<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-12">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row justify-content-center">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">{{appname}} системд бүртгүүлнэ үү!</h1>
                  </div>
                   <form class="user">
                        <div class="form-group">
                            <div class="btn-group text-center" role="group" >
                                <button type="button" class="btn btn-secondary" v-bind:class="[isStudent ? 'btn-success' : '']" @click="isStudent=true">Сурагч</button>
                                <!-- <button type="button" class="btn btn-secondary" v-bind:class="[isStudent==false ? 'btn-success' : '']" @click="isStudent=false">Багш</button> -->
                            </div>
                        </div>
                        <!-- <div class="form-group">
                        <input type="text" v-if="isStudent" v-model.trim="registerForm.studentCode" class="form-control form-control-user" placeholder="Оюутны кодоо оруулна уу">
                        </div> -->
                        <div class="alert alert-warning" role="alert">
                            Энд оруулсан имэйл хаяг,нууц үгээ дараа нэвтрэхэд ашиглагдана.
                        </div>
                        <div class="form-group">
                            <label>Имэйл </label>
                            <input type="email" v-model.trim="registerForm.email" class="form-control" id="exampleInputEmail" placeholder="Имэйл хаяг">
                        </div>
                        
                        <div class="form-group row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>Нууц үг</label>
                                <input type="password" v-model.trim="registerForm.password" class="form-control " id="exampleInputPassword" placeholder="Нууц үг">
                            </div>
                            <div class="col-sm-6">
                                <label>Нууц үгээ дахин оруулах</label>
                                <input type="password" v-model.trim="reenterpassword" class="form-control " id="exampleRepeatPassword" placeholder="Нууц үгээ дахин оруулна уу">
                            </div>
                        </div>
                        <button @click="register" type="button"  class="btn btn-primary btn-block">
                            Бүртгүүлэх
                        </button>


         
                    </form>
                    <hr>

                    <div class="text-center">
                        <router-link to="/login">
                            <a class="small" >Буцах</a>
                        </router-link>
                        
                    </div>
                  <hr>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>

const fb = require('../../firebaseConfig.js')
export default {
    name: "Register",
    data() {
        return {
                    appname: null,
        showlogo: null,
        logopath:null,
            registerForm: {
                email: '',
                password: '',
                name:'',
                lastname:'',
                phone:'',
                studentCode:null,
                password:null,
                
            },
            reenterpassword:null,
            isStudent:true
        };
    },
    created(){
      if(fb.APPNAME)
        this.appname=fb.APPNAME;
      if(fb.SHOWLOGO)
        this.showlogo=fb.SHOWLOGO;
      if(fb.LOGOPATH)
        this.logopath=fb.LOGOPATH;
    },
    methods: {
        login() {
            this.performingRequest = true
            fb.auth.signInWithEmailAndPassword(this.registerForm.email, this.registerForm.password).then(user => {
                this.$store.commit('setCurrentUser', user.user)
                this.$store.dispatch('fetchUserProfile')
                this.performingRequest = false
                this.$router.push('/hello')
            }).catch(err => {
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        },
        addStudent(){
            if(this.registerForm!=null 
            // && this.registerForm.studentCode!=null 
            // && this.registerForm.studentCode!=''
            && this.registerForm.password!=null
            && this.registerForm.password!=''
            && this.registerForm.password==this.reenterpassword
            // && this.registerForm.name!=null
            // && this.registerForm.name!=''
            // && this.registerForm.lastname!=null
            // && this.registerForm.lastname!=''
            && this.registerForm.email!=null
            && this.registerForm.email!=''){
                // fb.db.collection('students').doc(this.registerForm.studentCode).get().then(std=>{
                //     if(std!=null && std.exists && std.data().user==null){
                fb.auth.createUserWithEmailAndPassword(this.registerForm.email, this.registerForm.password).then(user => {

                    this.$store.commit('setCurrentUser', user.user)

                    fb.usersCollection.doc(user.user.uid).set({
                        // name: this.registerForm.name,
                        email: this.registerForm.email,
                        // phone: this.registerForm.phone,
                        // lastname: this.registerForm.lastname,
                        role:"student",
                        customer: null,
                        verified:false,
                        checked:true
                    }).then(() => {
                        // std.ref.update({'user': fb.usersCollection.doc(user.user.uid)});
                        this.$store.dispatch('fetchUserProfile')
                        // this.$store.dispatch('setEnabledTrue')   
                        this.performingRequest = false
                        this.$router.push('/hello');
                    }).catch(err => {
                        console.log(err)

                    })
                }).catch(err => {
                    console.log(err)

                })
                    // }
                    // else{
                    //     alert("Та энэ системд нэврэх эрхгүй байна.")
                    // }
                // })

                
            }
            else{
                alert("Бүх талбаруудыг бөглөнө үү")
            }
        },
        addTeacher(){
            if(this.registerForm!=null 
            // && this.registerForm.studentCode!=null 
            // && this.registerForm.studentCode!=''
            && this.registerForm.password!=null
            && this.registerForm.password!=''
            && this.registerForm.password==this.reenterpassword
            && this.registerForm.name!=null
            && this.registerForm.name!=''
            && this.registerForm.lastname!=null
            && this.registerForm.lastname!=''
            && this.registerForm.email!=null
            && this.registerForm.email!=''){
                // fb.db.collection('students').doc(this.registerForm.studentCode).get().then(std=>{
                //     if(std!=null && std.exists && std.data().user==null){
                        fb.auth.createUserWithEmailAndPassword(this.registerForm.email, this.registerForm.password).then(user => {

                            this.$store.commit('setCurrentUser', user.user)

                            fb.usersCollection.doc(user.user.uid).set({
                                name: this.registerForm.name,
                                email: this.registerForm.email,
                                phone: this.registerForm.phone,
                                lastname: this.registerForm.lastname,
                                role:"teacher",
                                // student: std.ref,
                                checked:true
                            }).then(() => {
                                // std.ref.update({'user': fb.usersCollection.doc(user.user.uid)})
                                this.$store.dispatch('fetchUserProfile')
                                this.$store.dispatch('setEnabledTrue')   
                                this.performingRequest = false
                                this.$router.push('/hello')
                            }).catch(err => {
                                console.log(err)

                            })
                        }).catch(err => {
                            console.log(err)

                        })
                //     }
                //     else{
                //         alert("Та энэ системд нэврэх эрхгүй байна.")
                //     }
                // })

                
            }
            else{
                alert("Бүх талбаруудыг бөглөнө үү")
            }
        },
        register(){
            if(this.isStudent)
                this.addStudent();
            // else {
            //     this.addTeacher();
            // } 
        },

    },
  
};
</script>

